import Vue from 'vue'
import Vuex from 'vuex'
import backoffice from './modules/backoffice.store'
import location from './modules/location.store'
import frontoffice from './modules/frontoffice.store'
import client from './modules/client.store'
import tool from './modules/tool.store'
import kpis from './modules/kpis.store'
import radar from './modules/radar.store'
import gmb from './modules/gmb.store'
import qa from './modules/qa.store'
import localPost from './modules/localpost.store'
import userexpress from './modules/userexpress.store'
import ohgroup from './modules/ohgroup.store'
import presencemanagement from './modules/presencemanagement.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    backoffice,
    location,
    frontoffice,
    client,
    tool,
    kpis,
    radar,
    gmb,
    qa,
    localPost,
    userexpress,
    ohgroup,
    presencemanagement,
  },
  strict: process.env.NODE_ENV !== 'production',
})
